import "./reducer.js";
import "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
//#region src/redux/config.ts
var useHomeDispatch = () => useDispatch();
var useHomeSelector = useSelector;
//#endregion
export { useHomeDispatch, useHomeSelector };

//# sourceMappingURL=config.js.map